type CancelReason = string | undefined;

const controllers = new Set<AbortController>();

export const HttpCancelService = {
  add(controller: AbortController) {
    controllers.add(controller);
  },
  remove(controller: AbortController) {
    controllers.delete(controller);
  },
  cancelAll(reason: CancelReason = 'route-change') {
    controllers.forEach((controller) => controller.abort(reason));
    controllers.clear();
  }
};
